import _ from 'lodash';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../helpers/reselectHelpers';
import {makeGetCalendarData} from '../../../../../store/data/calendarVersions/calendarVersionsSelectors';
import {getCalendars, getCalendarVersions} from '../../../../../store/data/dataSelectors';
import {getTimeFormat} from '../../../../../store/data/preferences/preferencesSelectors';
import {
  addAdditionalGuestsAction,
  insertMeetingTimesAsyncAction,
  selectSchedulingCalendarVersionAction,
  updateDraftSchedulingLinkAction,
  updateMeetingDurationAction,
  updateStandardAvailabilityAction,
} from '../../../../../store/panels/calendars/scheduling/calendarsPanelSchedulingActions';
import {
  getDraftSchedulingLink,
  getSchedulingCalendarVersionId,
  getSelectedStandardSlots,
  getTrueAvailabilityStatus,
  getVisualParticipants,
} from '../../../../../store/panels/calendars/scheduling/calendarsPanelSchedulingSelectors';
import {getPanel} from '../../../../../store/panels/panelsSelectors';
import {MeetingSettingsPanel, MeetingSettingsPanelPublicProps} from './meetingSettingsPanel';

/*
 * Selectors.
 */

function makeGetIsPopout() {
  return createSelector([getPanel], (panel) => Boolean(panel && panel.shouldForcePopout));
}

const getCalendarNames = createSelector(
  [getDraftSchedulingLink, getCalendarVersions, getCalendars],
  (draftSchedulingLink, calendarVersions, calendars) =>
    _(draftSchedulingLink.doubleBookingCalendarVersions)
      .map((calendarVersionId) => calendarVersions[calendarVersionId])
      .compact()
      .map((calendarVersion) => calendars[calendarVersion.calendarId]?.organizerAddress)
      .compact()
      .uniq()
      .value(),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<MeetingSettingsPanelPublicProps>()(() => ({
  selectedCalendarData: makeGetCalendarData(getSchedulingCalendarVersionId),
  selectedSlots: getSelectedStandardSlots,
  trueAvailabilityStatus: getTrueAvailabilityStatus,
  draftLink: getDraftSchedulingLink,
  isPopout: makeGetIsPopout(),
  visualParticipants: getVisualParticipants,
  initialTimeFormat: getTimeFormat,
  calendarNames: getCalendarNames,
}));

const mapDispatchToProps = makeMapDispatchToProps<MeetingSettingsPanelPublicProps>()(({panelId}) => ({
  onClearSlots: () => updateStandardAvailabilityAction(panelId, []),
  onInsertMeetingTimes: () => insertMeetingTimesAsyncAction(panelId),
  onUpdateSchedulingLink: (changes) => updateDraftSchedulingLinkAction(panelId, changes),
  onUpdateCalendarVersionId: (newId) => selectSchedulingCalendarVersionAction(panelId, newId),
  onUpdateMeetingDuration: (durationMinutes) => updateMeetingDurationAction(panelId, durationMinutes),
  onAddAdditionalGuests: (newGuests) => addAdditionalGuestsAction(panelId, newGuests),
}));

export const MeetingSettingsPanelContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MeetingSettingsPanel);
